// TODO: Refactor this file completely

const state = {
    new: 0,
    appTaken: 0,
    documentsReceived: 0,
    submittedToLender: 0,
    conditionallyApproved: 0,
    invoiceRequested: 0,
    invoiceReturned: 0,
    optionsSent: 0,
    optionsReceived: 0,
    loanSubmitted: 0,
    loanApproved: 0,
    contractSent: 0,
    contractReceived: 0,
    settled: 0,
    completed: 0,

    new_application_status_id: 1,
    appTaken_application_status_id: 2,
    documentsReceived_application_status_id: 3,
    submittedToLender_application_status_id: 4,
    conditionallyApproved_application_status_id: 5,
    invoiceRequested_application_status_id: 6,
    invoiceReturned_application_status_id: 7,
    optionsSent_application_status_id: 8,
    optionsReceived_application_status_id: 9,
    loanSubmitted_application_status_id: 10,
    loanApproved_application_status_id: 11,
    contractSent_application_status_id: 12,
    contractReceived_application_status_id: 13,
    settled_application_status_id: 14,
    completed_application_status_id: 15,
    usersViewingApp: [],
    currentStatusId: null
};

//don't put the async operation inside the mutations. mutation should be sync.
const mutations = {
    async UpdateUsersViewingApp(state, payload) {
        state.usersViewingApp = payload
    },
    changeStatus(state, payload) {
        state.currentStatusId = state[`${payload.stage}_application_status_id`] || state.currentStatusId;
        state[payload.stage] = payload.value;
        if (payload.value == 2) {
            $store.dispatch("appStore/application/set", {
                application_status_id: state.currentStatusId
            })
        }
    },
    resetStatus(state, payload) {
        state.currentStatusId = payload.status_id - 1

        if (state["new"] != 0 && payload.status_id < 1) {
            state["new"] = 1;
        }
        if (state["appTaken"] != 0 && payload.status_id < 2) {
            state["appTaken"] = 1;
        }
        if (state["documentsReceived"] != 0 && payload.status_id < 3) {
            state["documentsReceived"] = 1;
        }
        if (state["submittedToLender"] != 0 && payload.status_id < 4) {
            state["submittedToLender"] = 1;
        }
        if (state["conditionallyApproved"] != 0 && payload.status_id < 5) {
            state["conditionallyApproved"] = 1;
        }
        if (state["invoiceRequested"] != 0 && payload.status_id < 6) {
            state["invoiceRequested"] = 1;
        }
        if (state["invoiceReturned"] != 0 && payload.status_id < 7) {
            state["invoiceReturned"] = 1;
        }
        if (state["optionsSent"] != 0 && payload.status_id < 8) {
            state["optionsSent"] = 1;
        }
        if (state["optionsReceived"] != 0 && payload.status_id < 9) {
            state["optionsReceived"] = 1;
        }
        if (state["loanSubmitted"] != 0 && payload.status_id < 10) {
            state["loanSubmitted"] = 1;
        }
        if (state["loanApproved"] != 0 && payload.status_id < 11) {
            state["loanApproved"] = 1;
        }
        if (state["contractSent"] != 0 && payload.status_id < 12) {
            state["contractSent"] = 1;
        }
        if (state["contractReceived"] != 0 && payload.status_id < 13) {
            state["contractReceived"] = 1;
        }
        if (state["settled"] != 0 && payload.status_id < 14) {
            state["settled"] = 1;
        }
        if (state["completed"] != 0 && payload.status_id < 15) {
            state["completed"] = 1;
        }
    },
    initialiseStatus(state, payload) {
        state.currentStatusId = payload.status_id - 1

        if (payload.status_id > 1) {
            state["new"] = 2;
        } else if (payload.status_id == 1) {
            state["new"] = 1;
        }
        if (payload.status_id > 2) {
            state["appTaken"] = 2;
        } else if (payload.status_id == 2) {
            state["appTaken"] = 1;
        }
        if (payload.status_id > 3) {
            state["documentsReceived"] = 2;
        } else if (payload.status_id == 3) {
            state["documentsReceived"] = 1;
        }
        if (payload.status_id > 4) {
            state["submittedToLender"] = 2;
        } else if (payload.status_id == 4) {
            state["submittedToLender"] = 1;
        }
        if (payload.status_id > 5) {
            state["conditionallyApproved"] = 2;
        } else if (payload.status_id == 5) {
            state["conditionallyApproved"] = 1;
        }
        if (payload.status_id > 6) {
            state["invoiceRequested"] = 2;
        } else if (payload.status_id == 6) {
            state["invoiceRequested"] = 1;
        }
        if (payload.status_id > 7) {
            state["invoiceReturned"] = 2;
        } else if (payload.status_id == 7) {
            state["invoiceReturned"] = 1;
        }
        if (payload.status_id > 8) {
            state["optionsSent"] = 2;
        } else if (payload.status_id == 8) {
            state["optionsSent"] = 1;
        }
        if (payload.status_id > 9) {
            state["optionsReceived"] = 2;
        } else if (payload.status_id == 9) {
            state["optionsReceived"] = 1;
        }
        if (payload.status_id > 10) {
            state["loanSubmitted"] = 2;
        } else if (payload.status_id == 10) {
            state["loanSubmitted"] = 1;
        }
        if (payload.status_id > 11) {
            state["loanApproved"] = 2;
        } else if (payload.status_id == 11) {
            state["loanApproved"] = 1;
        }
        if (payload.status_id > 12) {
            state["contractSent"] = 2;
        } else if (payload.status_id == 12) {
            state["contractSent"] = 1;
        }
        if (payload.status_id > 13) {
            state["contractReceived"] = 2;
        } else if (payload.status_id == 13) {
            state["contractReceived"] = 1;
        }
        if (payload.status_id > 14) {
            state["settled"] = 2;
        } else if (payload.status_id == 14) {
            state["settled"] = 1;
        }
        if (payload.status_id > 15) {
            state["completed"] = 2;
        } else if (payload.status_id == 15) {
            state["completed"] = 1;
        }
    }
};

const actions = {

    async changeStatus(context, payload) {

        const applicationStatusKey = `${payload.stage}_application_status_id`;
        const applicationStatusId = state[applicationStatusKey];

        if (applicationStatusId && payload.value == 2)
            context.rootState.initAppData.application_status_id = applicationStatusId;

        //find what status we're up to by getting the state appended with app status id
        let headers = {headers: {Authorization: "Bearer " + payload.token}};

        if (
            payload.stage == "createTask" &&
            payload.remindMe &&
            payload.taskName
        ) {
            context.dispatch("createTask", payload);
        } else {

            let url = "/api/application/" + payload.appId;
            let data = {}

            if (Ambition.useEmailBuilder()) {

                data = {
                    application_status_id: applicationStatusId || context.rootState.initAppData.application_status_id,
                    resent: payload.resent ? payload.resent : false,
                    email: payload.email ? payload.email : false,
                    completed: payload.value === 2 ? 1 : 0,
                    insurances: payload.insurances ? payload.insurances : false,
                }

            } else {

                data = {
                    application_status_id: applicationStatusId || context.rootState.initAppData.application_status_id,
                    resent: payload.resent ? payload.resent : false,
                    note: payload.note
                        ? payload.note
                        : payload.notes
                            ? payload.notes
                            : "",
                    emails: payload.emails,
                    approvalEmailData: payload.approvalEmailData || false,
                    notes: payload.note
                        ? payload.note
                        : payload.notes
                            ? payload.notes
                            : "",
                    cc: payload.cc,
                    subject: payload.subject || null,
                    subject2: payload.subject2 || null,
                    sellerDocuments: payload.sellerDocuments
                        ? payload.sellerDocuments
                        : null,
                    included: payload.included ? payload.included : null,
                    sendNotificationToApplicants: payload.sendNotificationToApplicants
                        ? payload.sendNotificationToApplicants
                        : null,
                    completed: payload.value === 2 ? 1 : 0,
                    attachments: payload.attachments ? payload.attachments : null,
                    documents: payload.documents ? payload.documents : null, // new tab,
                    force_settlement: payload.forceSettled
                        ? payload.forceSettled
                        : null,
                    template: payload.selectedTemplate
                        ? payload.selectedTemplate
                        : null
                };
            }

            // only send remittanceDate if and only if remittance date exists on the payload
            if (payload.remittanceDate) {
                data.remittance_date = payload.remittanceDate;
            }

            // only send lenderApplicationId and lenderContractNumber if and only if the fields exists on the payload
            if (payload.lenderContractNumber) {
                data.lender_contract_number = payload.lenderContractNumber;
            }

            // send review request on complete application
            if (payload.sendReviewRequest) {
                data.send_review_request = payload.sendReviewRequest;
            }

            if (payload.noReviewRequestReason) {
                data.no_review_request_reason = payload.noReviewRequestReason;
            }

            let res;
            try {
                res = await axios.patch(url, data, headers);
            } catch (e) {
                throw e;
            }

            context.commit("changeStatus", payload);

            if (payload.value == 2) {
                context.commit("resetStatus", {
                    status_id: res.data.application_status_id
                });
            }

            return res;
        }
    },
    createTask(context, payload) {
        // post a request to create a task for this app with the status stage name
        let headers = {headers: {Authorization: "Bearer " + payload.token}};
        let url = "/api/application/" + payload.appId + "/remind-me";
        let data = {
            user_id: payload.userId,
            due_date: payload.remindMe,
            time: payload.time,
            task_name: payload.taskName
                ? payload.taskName
                : "Application " +
                payload.appId +
                " was changed to status " +
                payload.stage +
                "."
        };
        axios
            .post(url, data, headers)
            .then(function (value) {
                // TODO:
            })
            .catch(function (error) {
                console.error(error);
            });
    },
    usersViewingApp(context, payload) {
        context.commit("UpdateUsersViewingApp", payload)
    },
    initialiseStatus(context, payload) {
        //status_id:5 e.g.
        context.commit("initialiseStatus", payload);
    }
};

const getters = {
    new: state => {
        return state.new
    },
    appTaken: state => {
        return state.appTaken
    },
    documentsReceived: state => {
        return state.documentsReceived
    },
    submittedToLender: state => {
        return state.submittedToLender
    },
    conditionallyApproved: state => {
        return state.conditionallyApproved
    },
    invoiceRequested: state => {
        return state.invoiceRequested
    },
    invoiceReturned: state => {
        return state.invoiceReturned
    },
    optionsSent: state => {
        return state.optionsSent
    },
    optionsReceived: state => {
        return state.optionsReceived
    },
    loanSubmitted: state => {
        return state.loanSubmitted
    },
    loanApproved: state => {
        return state.loanApproved
    },
    contractSent: state => {
        return state.contractSent
    },
    contractReceived: state => {
        return state.contractReceived
    },
    settled: state => {
        return state.settled
    },
    completed: state => {
        return state.completed
    },

    currentStatusId: state => state.currentStatusId,

    usersViewingApp: state => state.usersViewingApp
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
